import { UserField } from '@dadohr/shared/domainTypes/experience';
import { CustomUserField } from '@dadohr/shared/domainTypes/org';
import { Rule } from '@dadohr/shared/domainTypes/rules';
import {
  Button,
  Dialog,
  DialogContent,
  Typography
} from '@material-ui/core';
import { isEmptyRule, RuleBuilder } from '../../features/Experiences/components/RuleBuilder';
import { useModel } from '../../hooks/useModel';
import { useUnsafeTranslation } from '../../i18next';
import { guessCurrentTimezone } from '../../services/time';
import { useUserRuleConfigWithAutocompletion } from '../../services/user';
import { DialogActionsHeader } from '../DialogActionsHeader';
import { DialogActionsWithSlots } from '../DialogActionsWithSlots';

export const UserFilterDialog = ({
  open,
  onClose,
  value,
  onChange,
  orgId,
  customFields,
  tz,
  templateRules,
  experienceTemplateId,
  title = 'Edit filters'
}: {
  open: boolean;
  onClose: () => void;
  value: Rule<UserField> | null;
  onChange: (nextValue: Rule<UserField> | null) => void;
  orgId: string;
  customFields: CustomUserField[];
  tz?: string;
  templateRules?: Rule<UserField> | null;
  experienceTemplateId?: string;
  title?: string;
}) => {
  const timezone = tz ? tz : guessCurrentTimezone();
  const { t } = useUnsafeTranslation();
  const config = useUserRuleConfigWithAutocompletion(orgId, customFields, timezone, 
    experienceTemplateId ? {
      orgId,
      experienceTemplateId
    } : undefined
  );

  const [model, setModel] = useModel(value);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogActionsHeader
        left={<Typography variant="h4">{t(title)}</Typography>}
      >
        {templateRules && !isEmptyRule(templateRules) && (
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={() => setModel(templateRules)}
          >
            {t('Use template enrollment rules')}
          </Button>
        )}
      </DialogActionsHeader>
      <DialogContent>
        <RuleBuilder
          value={model}
          onChange={setModel}
          config={config}
          nullable
          showEmptyRowWhenNull={false}
        />
      </DialogContent>
      <DialogActionsWithSlots
        left={
          <Button
            variant="outlined"
            color="primary"
            onClick={() => {
              onChange(null);
              onClose();
            }}
          >
            {t('Remove filters')}
          </Button>
        }
        right={
          <>
            <Button onClick={onClose}>{t('Cancel')}</Button>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                onChange(model);
                onClose();
              }}
            >
              {t('Apply')}
            </Button>
          </>
        }
      />
    </Dialog>
  );
};